import { handleActions } from 'redux-actions';
import { createNSActions, updateStateReducer } from '../../utils/redux';
import {
  getRequest,
  getServiceConfigByName,
  getChannelByName,
} from '../../api/ticket';
import { getStaffList } from '../../api/gems';

const actions = createNSActions('VIEWS.REQUEST_DETAIL', {}, [
  'POPULATE',
  'LOAD_START',
  'LOADED',
]).views.requestDetail;

const defaultState = {
  isLoading: true,

  requestId: null,
  request: null,
  channel: null,
  serviceConfig: null,
  staffList: null,
};

export const reducer = handleActions({
  [actions.populate]: updateStateReducer,
  [actions.loaded]: updateStateReducer,
  [actions.loadStart]: updateStateReducer,
}, defaultState);

export const loadRequestResources = () =>
  (dispatch, getState) => {
    const {
      views: {
        requestDetail: {
          requestId,
          request: requestCache,
          serviceConfig: serviceConfigCache,
          channel: channelCache,
        },
      },
      session: {
        affiliateId,
      },
    } = getState();

    const promise = requestCache ? Promise.resolve(requestCache) : getRequest(requestId);

    dispatch(actions.loadStart({ isLoading: true }));

    // Staff list is not UI critical, we could load independent
    getStaffList(affiliateId).then((staffList) => {
      dispatch(actions.loaded({
        staffList,
      }));
    });

    return promise.then(request =>
      Promise.all([
        serviceConfigCache || getServiceConfigByName(affiliateId, request.type),
        channelCache || getChannelByName(affiliateId, request.channel),
      ]).then(([serviceConfig, channel]) => {
        dispatch(actions.loaded({
          request,
          serviceConfig,
          channel,
          isLoading: false,
        }));
      }));
  };

export const populate = (requestId, { request, channel, serviceConfig }) =>
  (dispatch) => {
    dispatch(actions.populate({
      ...defaultState,
      requestId,
      request,
      channel,
      serviceConfig,
    }));

    return dispatch(loadRequestResources());
  };



// WEBPACK FOOTER //
// ./src/views/requests/RequestDetailState.js